import { Injectable, Inject } from '@angular/core';
import { GridDataService } from './core/griddata.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DashboardService } from '../odata-services/services/dashboard.service';



//import { Sortimentsauswahl } from '../models/sortimente/sortimentsauswahl.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardDataService extends GridDataService {
    
  public odataService: DashboardService;
  
  
    constructor( @Inject(DashboardService)  service: DashboardService, @Inject(NotificationService) notificationService?: NotificationService) { 
      super(service,null,notificationService); 
      this.odataService = service;
    }
  
    //public SaveIsZugeordnet(item : Sortimentsauswahl, state: State) : void
   /*  public SaveIsZugeordnet(item : any, state: State) : void
    { 
        this.update(item);
        this.saveChanges(state);
    } */


}
